export type ContentFeeGate = 'NONE' | 'ORG_MISMATCH' | 'NOT_STARTED' | 'EXHAUSTED' | 'EXPIRED'

/**
 * 관리자 결제 안내 토큰(서버 `ContentFeeGate.notice`). 학습 게이트는 바꾸지 않는다.
 * - PERIOD_ENDED: 이용 기간(28일)은 지났지만 유예 기간 안이라 학습은 계속 가능한 상태.
 * - PURCHASABLE: 직전 결제 후 21일이 지나 재결제를 받을 수 있는 상태. 서버 재결제 쿨다운과 같은 기준이다.
 */
export type ContentFeeNotice = 'PERIOD_ENDED' | 'PURCHASABLE'

/** 학습이 막혔고 지금 결제로 풀 수 있는 상태. */
export function requiresContentPayment(
  gate: ContentFeeGate | null | undefined,
  notice?: ContentFeeNotice | null,
): boolean {
  if (gate === 'NONE' || gate === 'EXPIRED') return true
  // 레슨 소진은 재결제 쿨다운(21일)이 끝나야 결제할 수 있다. 2026-10-22 결정.
  return gate === 'EXHAUSTED' && notice === 'PURCHASABLE'
}

export type ContentPaymentBadge = 'REQUIRED' | 'PERIOD_ENDED' | 'AVAILABLE'

/**
 * 관리자 화면의 콘텐츠 결제 배지 종류.
 * - REQUIRED: 학습이 막힌 상태(NONE·EXPIRED·쿨다운이 끝난 EXHAUSTED). 문구 "결제 필요". 팀 결정 2026-07-29, 2026-10-22.
 * - PERIOD_ENDED: 이용 기간 종료·유예 중(게이트 통과). 문구 "결제 필요". 팀 결정 2026-09-21, 2026-10-22.
 * - AVAILABLE: 이용 기간 중이지만 직전 결제 21일이 지나 재결제 가능. 문구 "추가 결제 가능". 2026-10-22 결정.
 * 모두 같은 결제 모달을 연다. 교재 알림 대체 등 학습 차단 판단은 REQUIRED만 쓴다.
 * 관리자 전용이며 학습자 앱은 사용하지 않는다.
 */
export function contentPaymentBadge(
  gate: ContentFeeGate | null | undefined,
  notice: ContentFeeNotice | null | undefined,
): ContentPaymentBadge | null {
  if (requiresContentPayment(gate, notice)) return 'REQUIRED'
  if (gate) return null
  if (notice === 'PERIOD_ENDED') return 'PERIOD_ENDED'
  if (notice === 'PURCHASABLE') return 'AVAILABLE'
  return null
}
